export const MenuStyles = {
    menuBar: {
        minHeight: 1024,
        overflow: 'auto',
        backgroundColor: '#f2f2f2'
    }
};
